import script from "./JaMaterialSelectCell.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMaterialSelectCell.vue?vue&type=script&setup=true&lang=js"

import "./JaMaterialSelectCell.vue?vue&type=style&index=0&id=afcfbb12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afcfbb12"]])

export default __exports__